/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ModelJobStates } from 'src/modules/modelTraining/types/trainingTypes';

export const jobStatusPrettifier = (status: ModelJobStates) => {
    switch (status) {
        case 'failed':
            return 'Failed';
        case 'inProgress':
            return 'In progress';
        case 'notStarted':
            return 'Not started';
        case 'succeeded':
            return 'Succeeded';
        default:
            return 'N/A';
    }
};
